/* eslint-disable no-param-reassign */
/* eslint-disable jsx-a11y/iframe-has-title */
/* eslint-disable no-restricted-globals */
import React, { FunctionComponent, useEffect, useState } from 'react';
import { Card, Divider, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import classes from './PlayerDiv.module.css';
import {
  findPlayerList,
  getDefaultAlertProps,
  getPlayerList,
  selectTheme,
} from '../../utils/utils';
import {
  API_STATUS_PROBLEM,
  DARK_THEME,
  LIGHT_THEME,
  WINDOW_H,
  WINDOW_V,
} from '../../constant/constants';
import { PlayerDto } from '../../dto/PlayerDto';
import { IApiResult } from '../../interface/IApiResult';
import { IAlertProps } from '../../interface/IAlertProps';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { PlayerSetupDto } from '../../dto/PlayerSetupDto';
import { apiPlayerSetupGet } from '../../service/apiPlayerSetupGet';

declare global {
  interface Window {
    webkit?: any;
  }
}

interface Props {
  selectThemeFromMain: number;
  onChange: (e: any) => void;
}

export const PlayerDiv: FunctionComponent<Props> = ({
  selectThemeFromMain,
  onChange,
}) => {
  const { accessToken, id, idOther, route, apiVersion, keyTitle, secureToken } =
    useParams();
  const [curTheme, setCurTheme] = useState(DARK_THEME);
  const [selectId, setSelectId] = useState<PlayerDto>({
    id: '',
    title: '',
    link: '',
  });
  const [playerSetupDto, setPlayerSetupDto] = useState<PlayerSetupDto>({
    isShow: 0,
    id: '',
    idOther: '',
    videoName: '',
    userColor: '',
  });
  const [listIdAll, setListIdAll] = useState<PlayerDto[]>([]);
  const [windowState, setWindowState] = useState(WINDOW_V);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [, setAlertProps] = useState<IAlertProps>(getDefaultAlertProps());

  const getUserColor = () => {
    let test = '#e4eaed;#1D2228';
    if (playerSetupDto.userColor !== undefined) {
      test = playerSetupDto.userColor?.toString().replaceAll('_', '#');
    }
    return test;
  };

  const getPlayerSetup = async () => {
    const apiResult: IApiResult = await apiPlayerSetupGet(
      id ?? '',
      keyTitle ?? '',
      route ?? '',
      accessToken ?? '',
      apiVersion ?? '',
      secureToken ?? ''
    );
    if (apiResult.isSuccess) {
      setPlayerSetupDto(apiResult.data);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const selectVideo = (selectPlayer: PlayerDto) => {
    setSelectId(selectPlayer);
    onChange(selectPlayer.link);
  };

  useEffect(() => {
    setCurTheme(selectThemeFromMain ?? LIGHT_THEME);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectThemeFromMain]);

  useEffect(() => {
    setWindowWidth(window.innerWidth);
    let cnt = WINDOW_V;
    if (window.innerWidth > window.innerHeight) {
      cnt = WINDOW_H;
    }
    setWindowState(cnt);
  }, [id, idOther]);

  const handlerChange = () => {
    let cnt = WINDOW_V;
    if (window.innerWidth > window.innerHeight) {
      cnt = WINDOW_H;
    }
    setWindowState(cnt);
    setWindowWidth(window.innerWidth);
  };

  useEffect(() => {
    setListIdAll(getPlayerList(playerSetupDto));
    setSelectId(
      findPlayerList(getPlayerList(playerSetupDto), playerSetupDto ?? '', false)
    );
  }, [playerSetupDto]);

  useEffect(() => {
    getPlayerSetup();
    window.addEventListener('resize', handlerChange, false);
    return () => {
      window.removeEventListener('resize', handlerChange, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        userSelect: 'none',
        background: selectTheme('#FFFFFF;#1D2228', curTheme, -1),
      }}
      className={classes.myDiv4}
    >
      <div
        className={
          windowState === WINDOW_V ? classes.container : classes.container2
        }
      >
        {playerSetupDto.isShow === 1 && (
          <div className={classes.divVideo}>
            <iframe
              id="audioIFrame"
              style={{
                width: '100%',
                height:
                  windowState === WINDOW_V
                    ? (windowWidth * 9) / 16
                    : (windowWidth * 9) / 16 / 1.5,
                border: 'none',
              }}
              src={`https://kinescope.io/embed/${selectId.id}`}
              allow="autoplay; fullscreen; picture-in-picture; encrypted-media; gyroscope; accelerometer; clipboard-write; screen-wake-lock;"
              // eslint-disable-next-line react/style-prop-object
            />
            <Stack padding="10px" spacing={1}>
              <Stack
                alignItems="center"
                direction="row"
                justifyContent="space-between"
              >
                <Typography
                  style={{
                    fontFamily: 'sans-serif',
                    fontSize: '14px',
                    fontWeight: '700',
                    textAlign: 'left',
                    color: selectTheme('#000000;#CDD7DF', curTheme, -1),
                  }}
                  component="text"
                >
                  {selectId.title.replaceAll('%20', ' ')}
                </Typography>
              </Stack>
              {windowState === WINDOW_V && <Divider />}
              {windowState === WINDOW_V && (
                <Stack paddingLeft="20px" paddingRight="20px" spacing={1}>
                  <Typography
                    style={{
                      fontFamily: 'sans-serif',
                      fontSize: '14px',
                      overflow: 'auto',
                      fontWeight: '400',
                      textAlign: 'left',
                      color: selectTheme('#000000;#CDD7DF', curTheme, -1),
                    }}
                    component="text"
                  >
                    Плейлист
                  </Typography>
                </Stack>
              )}
            </Stack>
          </div>
        )}
        {playerSetupDto.isShow === 1 && (
          <div className={classes.divVideoList}>
            <Stack spacing={1}>
              {listIdAll?.map((item) => (
                <Card
                  style={{
                    userSelect: 'none',
                    boxShadow: 'none',
                    borderRadius: '12px',
                    background: selectTheme(
                      selectId.id === item.id
                        ? getUserColor()
                        : '#e4eaed;#404952',
                      curTheme,
                      -1
                    ),
                  }}
                >
                  <Stack
                    padding="10px"
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    onClick={() => selectVideo(item)}
                  >
                    <img
                      style={{
                        width: '56px',
                        height: '32px',
                        border: 'none',
                        borderRadius: '4px',
                      }}
                      src={`https://kinescope.io/${item.id}/poster.xs.webp`}
                      alt="not found"
                    />
                    <Typography
                      style={{
                        fontFamily: 'sans-serif',
                        fontSize: '12px',
                        overflow: 'auto',
                        fontWeight: '400',
                        textAlign: 'left',
                        color: selectTheme('#000000;#CDD7DF', curTheme, -1),
                      }}
                      component="text"
                    >
                      {item.title.replaceAll('%20', ' ')}
                    </Typography>
                  </Stack>
                </Card>
              ))}
            </Stack>
          </div>
        )}
      </div>
    </div>
  );
};
